import { GridApi } from 'ag-grid-community';

import {
  arriveDistance,
  departDistance,
  arriveDistanceExportHeader,
  departDistanceExportHeader,
} from '../../translations/en.json';
import { H } from '../Context/constants';

/**
 * Columns omitted from CSV/Excel when visit log is embedded from visit-summary’s provider
 * row popup (`gridExportFileName` set): provider Person ID and patient chart ID.
 */
export const VISIT_SUMMARY_PROVIDER_POPUP_EXPORT_EXCLUDE_COL_IDS = new Set([
  'personnumber',
]);

/** Primary columns for CSV/Excel export, excluding HCPCS indicator column `H`. */
export function getVisitLogExportParams(gridApi: GridApi) {
  const { columnController } = gridApi as any;
  const columnKeys = (columnController?.getAllPrimaryColumns?.() ?? [])
    .map((c: { getColId: () => string }) => c.getColId())
    .filter((id: string) => id !== H);

  return {
    columnKeys,
    processHeaderCallback: (params: {
      column: {
        getColId: () => string;
        getColDef: () => { headerName?: string };
      };
    }) => {
      const id = params.column.getColId();
      if (id === arriveDistance) return arriveDistanceExportHeader;
      if (id === departDistance) return departDistanceExportHeader;
      const hn = params.column.getColDef().headerName;
      return hn != null && String(hn).trim() !== '' ? String(hn) : id;
    },
  };
}
